import { logUsage } from 'owa-analytics';
import getExtraCustomDataForDatapoint from './getExtraCustomDataForDatapoint';

export default function logUsageWithSxSCustomData(datapointName: string, sxsId: string) {
    const commonData = getExtraCustomDataForDatapoint(sxsId);
    logUsage(datapointName, commonData.customData, {
        cosmosOnlyData: JSON.stringify(commonData.cosmosOnlyData),
    });
}
